import React, { FC } from "react"
import styled from "styled-components"
import { ButtonGroup } from "../../button-group/ButtonGroup"

const Container = styled.div``

interface CardActionsCompProps {
  className?: string
}

const CardActionsComp: FC<CardActionsCompProps> = ({ className, children }) => {
  return (
    <Container className={className}>
      <ButtonGroup>{children}</ButtonGroup>
    </Container>
  )
}

export const CardActions = styled(CardActionsComp)``
